export default __webpack_public_path__ + "static/media/icon-hamburger.5273efa7.svg";